import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { ProposalService } from './proposal.service';
import { TodoService } from './todo.service';
import { QuestionService } from './question.service';
import { TransferRequestService } from './transfer-request.service';

/**
 * Sjednocený odznak schránky „Asistentka" v sidebaru = otevřené úkoly + čekající návrhy +
 * otevřené otázky + otevřené požadavky na přestup. Vlastní vzor jako dřívější
 * `ProposalService.pendingCount$` (feature/proposals-ui), jen přesunutý sem — samostatná
 * služba místo rozšiřování ProposalService o TodoService/QuestionService/TransferRequestService,
 * aby si tyto služby zůstaly vzájemně neznámé.
 *
 * SecuredComponent na pendingCount$ odebírá (s takeUntilDestroyed); komponenty, které mění
 * stav úkolů/návrhů/otázek/požadavků (TodoListComponent, ProposalsComponent,
 * QuestionListComponent, RequestListComponent), po každé akci volají refresh().
 */
@Injectable({
  providedIn: 'root'
})
export class AssistantBadgeService {
  pendingCount$ = new BehaviorSubject<number>(0);

  constructor(
    private proposalService: ProposalService,
    private todoService: TodoService,
    private questionService: QuestionService,
    private transferRequestService: TransferRequestService
  ) {
  }

  refresh(): void {
    forkJoin({
      proposals: this.proposalService.getQueue(),
      openTodos: this.todoService.getOpenCount(),
      openQuestions: this.questionService.getOpenCount(),
      openRequests: this.transferRequestService.getOpenCount()
    }).subscribe({
      next: ({ proposals, openTodos, openQuestions, openRequests }) =>
        this.pendingCount$.next(proposals.length + openTodos + openQuestions + openRequests),
      error: () => {}
    });
  }
}
